import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { retry, catchError } from 'rxjs/operators';
import { ConfigurationService } from '@config/configuration.service';
import { AppQuestionData } from '@models/app-question-data';
import { Observable } from 'rxjs/internal/Observable';
import { throwError } from 'rxjs/internal/observable/throwError';

@Injectable({
  providedIn: 'root'
})
export class DataDialogService  {
  
  backUrl: string = this.configSvc.configuration.UrlBackEnd;

  constructor(private http: HttpClient, private configSvc: ConfigurationService) { }

  sendContactSMS(data:AppQuestionData[]) : Observable<any[]>
  {
    const params = {
      AppQuestionData: data, 
      EncryptedStandardQuery: localStorage.getItem("StandardQueryEncripted")
    }
    return this.http.put<any>(this.backUrl + '/SendSMS', params)
    .pipe(retry(1), catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    
    let errorMessage = 'Unknown error!';

    if (error.error instanceof ErrorEvent) {
      errorMessage = 'An error occurred:', error.error.message;
    } else {
      errorMessage =
        `Error code ${error.status}\n
        Body: ${error.error}\n
        Message: ${error.message}`;
    }
    console.error(errorMessage);
    
    return throwError(errorMessage);
  };
}
